import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanCreateUser(loggedInUser) {
    return loggedInUser.role === Role.ADMIN;
}
export default CanCreateUser;